// extracted by mini-css-extract-plugin
export default {"newDelivery":"_1WBjQicz6_IS1argiGdf-9"};